import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'app-card-side-line',
    styleUrls: ['./card-side-line.component.scss'],
    template: ``,
})
export class AppCardSideLineComponent {
    @HostBinding('class')
    className: string = 'card-slide-line';

    @HostBinding('style.backgroundColor') get getBackgroundColor(): string {
        return this.lineColor || 'revert-layer';
    }

    @Input()
    lineColor?: string;
}
